import { Button, Modal } from '../../../_custom';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { handleDealApplicationDrawer, updateDealApplicationData } from '../../../../store/investor/action';
import styles from './DealSuccessModal.module.scss';
import { useSearchParams } from 'react-router-dom';
import { DealShareSuccess } from '../../../../assets/hostedassets';

interface DealSuccessModalProps {
    showSuccessModal: boolean | undefined;
    heading?: string;
    subHeading?: string;
    buttonText?: string;
    buttonOnClick?: () => void;
    queryParamsToClearOnClose?: string[];
    showCrossButton?: boolean;
    onCLose?: () => void;
}

const DealSuccessModal: React.FC<DealSuccessModalProps> = ({
    showSuccessModal,
    heading = 'Deal Shared',
    subHeading = 'Track ongoing deals with lenders',
    buttonText = '',
    buttonOnClick,
    queryParamsToClearOnClose = [],
    showCrossButton = false,
    onCLose,
}) => {
    const dispatch = useAppDispatch();
    const source = useAppSelector((state) => state.investor.dealApplicationDrawer.source);
    const [searchParams, setSearchParams] = useSearchParams();

    const closeDrawer = () => {
        if (queryParamsToClearOnClose.length > 0) {
            queryParamsToClearOnClose.forEach((param) => {
                searchParams.delete(param);
            });
            setSearchParams(searchParams);
        }
        if (onCLose) {
            onCLose();
        }
        dispatch(
            handleDealApplicationDrawer({
                open: false,
                source: '',
                dealId: '',
                heading: '',
                subHeading: '',
                width: '',
                showSuccessModal: false,
                profileGenerationStatus: '',
            }),
        );
    };

    const getText = () => {
        if (buttonText) return buttonText;
        if (source === 'editDeal') return 'Close';
        return 'View Deals';
    };

    return (
        <Modal
            style={{ height: '50%', width: '25%' }}
            withoutCloseButton={!showCrossButton}
            open={showSuccessModal ?? false}
            onClose={closeDrawer}
            persistent={true}
            size={'flexible'}
        >
            <div className={styles.ModalBody}>
                <img src={DealShareSuccess} alt={'Deal Shared'} className={styles.SuccessImg} />
                <div style={{ margin: '1rem 0 0.5rem 0' }} className={styles.Heading}>
                    {heading}
                </div>
                <p style={{ margin: '0 0 0.5rem 0', fontSize: '12px' }}>{subHeading}</p>
                <Button
                    variant={'primary'}
                    style={{ margin: '2rem  0 0 0', width: '50%' }}
                    text={getText()}
                    onClick={() => {
                        dispatch(updateDealApplicationData({ updatedLendersMap: [] }));
                        closeDrawer();
                        if (buttonOnClick) {
                            buttonOnClick();
                            return;
                        }
                    }}
                />
            </div>
        </Modal>
    );
};

export default DealSuccessModal;
